import { createAction, createReducer } from '@reduxjs/toolkit';

export enum DialogNames {
  Auth = 'Auth',
}

export interface OpenOptions {
  name: DialogNames;
}

const dialogOpened = createAction<OpenOptions>('dialog/modalOpened');
const dialogClosed = createAction<DialogNames>('dialog/modalClosed');

const dialogReducer = createReducer(
  {},
  {
    [dialogOpened.type]: (state, action) => {
      return {
        ...state,
        [action.payload.name]: {
          isShown: true,
        },
      };
    },
    [dialogClosed.type]: (state, action) => {
      return {
        ...state,
        [action.payload]: {
          isShown: false,
        },
      };
    },
  }
);

export { dialogOpened, dialogReducer, dialogClosed };
